import { render, staticRenderFns } from "./SPIFProfitabilityVariance.vue?vue&type=template&id=04a6041e"
import script from "./SPIFProfitabilityVariance.vue?vue&type=script&lang=js"
export * from "./SPIFProfitabilityVariance.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfitabilityVariance.vue?vue&type=style&index=0&id=04a6041e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports